import { SportsType, ThemeType } from "~/shared/enum";
import type { IAlert } from "~/shared/interfaces/alert.interface";

export const useStore = () => {
    const isLoading = useState<boolean>("isLoading", () => false);
    const isMaintenance = useState("isMaintenance", () => ({
        isShow: false,
        data: undefined,
    }));
    const isPopupShow = useState<boolean>("isPopupShow", () => false);
    const isSinginModal = useState<boolean>("isSinginModal", () => false);
    const isSingupModal = useState<boolean>("isSingupModal", () => false);
    const isMenuToggle = useState<boolean>("isMenuToggle", () => false);
    const isMobileRightSidebarToggle = useState<boolean>("isMobileRightSidebarToggle", () => false);
    const themeType = useState<ThemeType>("themeType", () => ThemeType.SAMPLE5);
    const prematchCategory = useState<any>("prematchCategory");
    const inplayCategory = useState<any>("inplayCategory");
    const eprematchCategory = useState<any>("eprematchCategory");
    const einplayCategory = useState<any>("einplayCategory");
    const sportSearchQuery = useState<any>("sportSearchQuery", () => {
        return {
            esports: false,
            type: SportsType.PREMATCH,
            sport: 0,
            league: 0,
            page: 1,
            limit: 15,
            sort: 1,
            search: "",
        };
    });

    const alert = useState<{ isShow: boolean; data: IAlert; type?: string; tab?: string }>("alert", () => {
        return {
            isShow: false,
            type: "",
            tab: "",
            data: {
                message: "",
                type: "success",
            },
        };
    });
    const betSlips = useState<any>("bet-slips", () => []);
    const bet = useState<any>("mbet-slip", () => undefined);
    const vBetSlips = useState<any>("vbet-slips", () => []);
    const bonusDividend = useState<any>("bonusDividend", () => []);
    const prohibitedDividend = useState<number>("prohibited");
    const maxDividend = useState<number>("max-dividend");
    const singleBetPenalty = useState<number>("singleBetPenalty");
    const signupSetting = useState<{ isMobileVerify: boolean; isReferCode: boolean; isPossibleSignup: boolean }>(
        "signup-setting",
    );
    const sportsCombination = useState<any>("sports-combination", () => undefined);
    const isMobileBetModal = useState<boolean>("isMobileBetModal", () => false);
    const isMobileMBetModal = useState<boolean>("isMobileMBetModal", () => false);
    const themeSetting = useState<any>("theme-setting", () => undefined);
    const vsportsSetting = useState<any>("vsports-setting", () => undefined);
    const hideVBetCart = useState<boolean>("hideVBetCart", () => false);
    const isCouponRollingModal = useState<boolean>("isCouponRollingModal", () => false);
    const couponRollingDetails = useState<any>("couponRollingDetails", () => null);

    const setIsLoading = (value: boolean) => {
        isLoading.value = value;
    };

    const setIsMaintenance = (value: any) => {
        isMaintenance.value = value;
    };

    const setIsPopupShow = (value: boolean) => {
        isPopupShow.value = value;
    };

    const setIsMenuToggle = (value: boolean) => {
        isMenuToggle.value = value;
    };

    const setIsMobileRightSidebarToggle = (value: boolean) => {
        isMobileRightSidebarToggle.value = value;
    };

    const setThemeType = (value: ThemeType) => {
        themeType.value = value;
    };

    const setprematchCategory = (value: any) => {
        prematchCategory.value = value;
    };

    const setInplayCategory = (value: any) => {
        inplayCategory.value = value;
    };

    const setEprematchCategory = (value: any) => {
        eprematchCategory.value = value;
    };

    const setEInplayCategory = (value: any) => {
        einplayCategory.value = value;
    };

    const setSportSearchQuery = (value: any) => {
        sportSearchQuery.value = value;
    };

    const setIsSigninModal = (value: boolean) => {
        isSinginModal.value = value;
    };

    const setIsSignupModal = (value: boolean) => {
        isSingupModal.value = value;
    };

    const setAlert = (value: { isShow: boolean; data: IAlert; type?: string; tab?: string }) => {
        alert.value = value;
    };

    const setBetSlips = (value: any) => {
        betSlips.value = value;
    };

    const setBet = (value: any) => {
        bet.value = value;
    };

    const setVBetSlips = (value: any) => {
        vBetSlips.value = value;
    };

    const setBonusDividend = (value: any) => {
        bonusDividend.value = value;
    };

    const setProhibitedDividend = (value: any) => {
        prohibitedDividend.value = value;
    };

    const setMaxDividend = (value: any) => {
        maxDividend.value = value;
    };

    const setSingleBetPenalty = (value: any) => {
        singleBetPenalty.value = value;
    };

    const setIsMobileBetModal = (value: any) => {
        isMobileBetModal.value = value;
    };

    const setIsMobileMBetModal = (value: any) => {
        isMobileMBetModal.value = value;
    };

    const setSignupSetting = (value: { isMobileVerify: boolean; isReferCode: boolean; isPossibleSignup: boolean }) => {
        signupSetting.value = value;
    };

    const setSportsCombination = (value: any) => {
        sportsCombination.value = value;
    };

    const setThemeSetting = (value: any) => {
        themeSetting.value = value;
    };

    const setVsportsSetting = (value: any) => {
        vsportsSetting.value = value;
    };

    const setHideVBetCart = (value: boolean) => {
        hideVBetCart.value = value;
    };

    const setIsCouponRollingModal = (value: boolean) => {
        isCouponRollingModal.value = value;
    };

    const setCouponRollingDetails = (value: any) => {
        couponRollingDetails.value = value;
    };

    return {
        isLoading,
        isMaintenance,
        isPopupShow,
        isSinginModal,
        isSingupModal,
        isMenuToggle,
        isMobileRightSidebarToggle,
        themeType,
        prematchCategory,
        inplayCategory,
        eprematchCategory,
        einplayCategory,
        sportSearchQuery,
        alert,
        bonusDividend,
        prohibitedDividend,
        maxDividend,
        singleBetPenalty,
        signupSetting,
        sportsCombination,
        betSlips,
        bet,
        vBetSlips,
        isMobileBetModal,
        isMobileMBetModal,
        themeSetting,
        vsportsSetting,
        hideVBetCart,
        isCouponRollingModal,
        couponRollingDetails,
        setIsLoading,
        setIsMaintenance,
        setIsPopupShow,
        setIsSigninModal,
        setIsSignupModal,
        setIsMenuToggle,
        setIsMobileRightSidebarToggle,
        setThemeType,
        setprematchCategory,
        setInplayCategory,
        setEprematchCategory,
        setEInplayCategory,
        setSportSearchQuery,
        setAlert,
        setBetSlips,
        setBet,
        setVBetSlips,
        setBonusDividend,
        setProhibitedDividend,
        setMaxDividend,
        setSingleBetPenalty,
        setSignupSetting,
        setSportsCombination,
        setIsMobileBetModal,
        setIsMobileMBetModal,
        setThemeSetting,
        setVsportsSetting,
        setHideVBetCart,
        setIsCouponRollingModal,
        setCouponRollingDetails,
    };
};
